import { useEffect } from "react";

function ScriptInjector({ scriptHtml }) {
  useEffect(() => {


    const loadGtag = () => {
      // Create a wrapper div to parse the HTML string
      // const wrapper = document.createElement("div");
      // wrapper.innerHTML = scriptHtml;
      // document.head.appendChild(wrapper)

      const node4 = document.createRange().createContextualFragment(scriptHtml)
document.head.appendChild(node4)

      // // Filter only <script> tags and append to <head>
      // Array.from(wrapper.querySelectorAll("script")).forEach((scriptTag) => {
      //   const script = document.createElement("script");

      //   // If the script is external (has src)
      //   if (scriptTag.src) {
      //     script.src = scriptTag.src;
      //     script.async = scriptTag.async;
      //   } else {
      //     // Inline script
      //     script.textContent = scriptTag.textContent;
      //   }

      //   script.className = "pixelScript"; // Optional: for future targeting/removal
      //   document.head.appendChild(script);
      // });



      // // Handle <noscript> tags
      // Array.from(wrapper.querySelectorAll("noscript")).forEach((noscriptTag) => {
      //   const noscriptContent = noscriptTag.innerHTML;

      //   // Create a container for the noscript content
      //   const noscriptContainer = document.createElement("div");
      //   noscriptContainer.style.display = "none"; // Mimic <noscript> behavior
      //   noscriptContainer.innerHTML = noscriptContent;

      //   document.body.appendChild(noscriptContainer);
      // })

      return ()=>{
        // Cleanup: Remove all appended scripts
        document.querySelectorAll(".pixelScript").forEach((el) => el.remove());
      }
    }


    if ('requestIdleCallback' in window) {
        requestIdleCallback(loadGtag);
      } else {
        setTimeout(loadGtag, 3000); // fallback delay
      }

      // Optional cleanup
      return () => {
        document.querySelectorAll("script.pixelScript").forEach((el) => el.remove());
      };
    }, [scriptHtml]);

  return null; // This component injects into <head>, doesn't render visibly
}

export default ScriptInjector;
